import * as Yup from 'yup';
import i18n from '../../../../../../translations/strings';
export const ValidationLoginSchema = Yup.object({
  username: Yup.string().lowercase().required(i18n.t('common.requiredField')).email(i18n.t('common.validEmail')),
  password: Yup.string().required(i18n.t('common.requiredField')),
});
